<template>
  <div class="home">
    <el-tabs type="border-card">
      <el-tab-pane label="图片">
        <el-alert
          :closable="false"
          title="禁止上传非公司业务范围的内容."
          type="error"
        ></el-alert>
        <el-upload
          :auto-upload="false"
          class="upload-demo"
          action="123"
          :on-change="beforeUploadImg"
          list-type="picture"
          accept="image/*"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">点击上传</el-button>

          <div slot="tip" class="el-upload__tip">
            只能上传jpg,jpeg,png,gif,bmp文件
          </div>
        </el-upload>
        <el-progress
          class="progress"
          :text-inside="true"
          :stroke-width="18"
          :percentage="percentageImg"
          v-if="percentageImg > 0 && percentageImg < 100"
        ></el-progress>

        <div class="inputWrapper" v-for="(item, index) in imgList" :key="index">
          <div class="inputItem">
            <div class="imgContent">
              <viewer>
                <img :src="item.url" alt />
              </viewer>
              <div
                style="display: none"
                class="qrcode"
                :id="'qrCodeUrl' + index"
              ></div>
              <viewer>
                <img :id="'img' + index" :src="item.erweImg" alt />
              </viewer>
            </div>

            <el-form size="small">
              <el-form-item label="图片链接：" :inline="true">
                <el-link type="primary">{{ item.imageUrl }}</el-link>
                <el-button
                  class="copyBtn tag-read"
                  v-clipboard:copy="item.imageUrl"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >复制链接</el-button
                >
              </el-form-item>
              <el-form-item label="请选择图片尺寸:">
                <el-select
                  allow-create
                  filterable
                  @change="changeSize(item, index)"
                  v-model="item.chosedSize"
                  placeholder="请选择图片尺寸"
                >
                  <el-option
                    v-for="item in Size"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="请选择图片质量：">
                <el-select
                  allow-create
                  @change="changeQuality(item, index)"
                  filterable
                  v-model="item.chosedQuality"
                  placeholder="请选择图片质量"
                >
                  <el-option
                    v-for="item in quality"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <el-collapse v-model="activeNames">
          <el-collapse-item title="上传历史" name="1">
            <div
              class="historyItem"
              v-for="(item, index) in imgHistory"
              :key="index"
            >
              <viewer>
                <img
                  :src="
                    item.pic_path +
                      '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_100/quality,q_50/format,jpg'
                  "
                />
              </viewer>
              <span
                >上传时间：{{
                  new Date(parseInt(item.create_time) * 1000)
                    .toLocaleString()
                    .replace(/:\d{1,2}$/, " ")
                }}</span
              >
              <span>上传地址：{{ item.pic_path }}</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="生成二维码">
        <el-input
          placeholder="请输入appid"
          v-model="qrCodeInfo.appid"
        ></el-input>
        <div style="margin-bottom: 20px"></div>
        <el-input v-model="qrCodeInfo.path" placeholder="请输入路径"></el-input>
        <div style="margin-bottom: 20px"></div>
        <el-input
          v-model="qrCodeInfo.width"
          placeholder="请输入图片宽度.单位px.最小280px,最大1280px.默认430"
        ></el-input>
        <div style="margin-bottom: 20px"></div>
        <div class="errorMessage">
          每个小程序最大生成十万个二维码，请谨慎使用！！！
        </div>
        <div style="margin-bottom: 20px"></div>

        <el-button type="primary" @click="toCode" size="smart">生成</el-button>
        <img :src="qrCodeInfourl" style="width: 100%" alt="" srcset="" />
      </el-tab-pane>

      <el-tab-pane label="文件">
        <el-alert
          :closable="false"
          title="禁止上传非公司业务范围的内容."
          type="error"
        ></el-alert>
        <!-- <input type="file" name=""  @change="beforeUploadFile" id=""> -->
        <el-upload
          :auto-upload="false"
          class="upload-demo"
          action="123"
          :on-change="beforeUploadFile"
          type="file"
          accept=".doc, .docx, .xls, .xlsx, .pdf, .rar, application/zip, .csv, .ppt, .apk, .pptx, text/plain"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传.doc, .docx, .xls, .xlsx,
            .pdf,.rar,.zip,.csv,.txt,.ppt,.apk,.pptx文件，文件不超过260M
          </div>
        </el-upload>
        <el-progress
          v-if="precentage"
          :text-inside="true"
          :stroke-width="26"
          :percentage="precentage"
        ></el-progress>
        <el-input
          v-model.trim="names.inputFileOriginName"
          placeholder="请输入备注"
        ></el-input>

        <div
          class="inputWrapper"
          v-for="(item, index) in fileListArr"
          :key="index"
        >
          <div class="inputItem">
            <div class="imgContent">{{ item }}</div>
          </div>
        </div>

        <el-collapse v-model="activeNames">
          <el-collapse-item title="上传历史" name="1">
            <div
              class="historyItem"
              v-for="(item, index) in fileListArrHistory"
              :key="index"
            >
              <span
                >上传时间：{{
                  new Date(parseInt(item.create_time) * 1000)
                    .toLocaleString()
                    .replace(/:\d{1,2}$/, " ")
                }}</span
              >
              <span>上传地址 </span
              ><span
                ><a
                  :href="item.pic_path"
                  target="view_window"
                  style="text-decoration: none"
                  download
                  >{{ item.pic_path }}</a
                ></span
              >
              <span>源文件名称:{{ item.file_name }} </span>

              <span>备注:{{ item.note }} </span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="视频">
        <el-alert
          title="禁止上传非公司业务范围的内容."
          type="error"
          :closable="false"
        ></el-alert>
        <div class="uploadVideoContainer">
          <el-upload
            class="upload-demo"
            action="123"
            :on-change="beforeUploadVideo"
            :auto-upload="false"
            accept="video/*"
            :file-list="fileList"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-progress
            class="progress"
            :text-inside="true"
            :percentage="percentageVideo"
            :stroke-width="18"
            v-if="percentageVideo > 0 && percentageVideo < 100"
          ></el-progress>
        </div>
        <el-alert
          :closable="false"
          class="alert"
          title="提示：视频上传完后,视频播放地址随后将通过企业微信消息推送给你"
          type="info"
        ></el-alert>
        <el-collapse v-model="activeNames1">
          <el-collapse-item title="上传历史" name="1">
            <div
              class="historyItem"
              v-for="(item, index) in videoHistory"
              :key="index"
            >
              <video
                muted
                autoplay="autoplay"
                controls="controls"
                webkit-playsinline
                playsinline
                x5-playsinline
                x-webkit-airplay="allow"
                :src="item.video_url"
              ></video>
              <span
                >上传时间：{{
                  new Date(parseInt(item.create_time) * 1000)
                    .toLocaleString()
                    .replace(/:\d{1,2}$/, " ")
                }}</span
              >
              <span>上传地址：{{ item.video_url }}</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const API_LOGIN = "https://sso.server.gaodun.com";
import QRCode from "qrcodejs2";
import Vue from "vue";
import axios from "axios";
import { Notification } from "element-ui";
import qs from "qs";
// let OSSFile = require("ali-oss");
import OSSFile from "ali-oss";
const videoUploadConfig = {
  timeout: "",
  partSize: "",
  parallel: "",
  retryCount: "",
  retryDuration: "",
  region: "cn-shanghai",
  userId: "20521440",
  authProgress: 0,
};
export default {
  name: "Home",
  components: { Notification },
  data() {
    return {
      domainList:['www.gwy.com','stark.pxo.cn'],
      names: {
        inputFileOriginName: "",
        originFileName: "",
      },
      listPageTionHistory: [],
      precentage: 0,
      qrCodeInfourl: "",
      qrCodeInfo: {
        appid: "",
        path: "",
        width: 340,
      },
      htmlinter: "",
      iframUrl: "",
      client: null,
      uploadUrl:'/huizhanapi/Zhandui.Member/getToken',
      ossConfig: {
       
        accessKeyId: "",
        accessKeySecret: "",
        region: "oss-cn-hangzhou",
        // bucket: "stark-pxo-cn-hz",
        bucket: "stark-pxo-cn-hz",
        stsToken: "",
        refreshSTSToken: "",
      },
      activeNames: ["0"],
      activeNames1: ["1"],
      token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJjbGllbnQueGhhZG1pbiIsImF1ZCI6InNlcnZlci54aGFkbWluIiwiaWF0IjoxNjAwODMyMDY0LCJleHAiOjE2MDA4MzkyNjQsInVpZCI6OX0.5IOlVrJfgdJpqP7RxyINQkDI4STuvaPEyKZvSzP-bmE",
      quality: [
        {
          value: "50",
          label: "50",
        },
        {
          value: "60",
          label: "60",
        },
        {
          value: "70",
          label: "70",
        },
        {
          value: "80",
          label: "80",
        },
        {
          value: "100",
          label: "100",
        },
      ],
      Size: [
        {
          value: "500",
          label: "500",
        },
        {
          value: "600",
          label: "600",
        },
        {
          value: "700",
          label: "700",
        },
        {
          value: "800",
          label: "800",
        },
        {
          value: "1000",
          label: "1000",
        },
      ],
      chosedQuality: "",
      chosedSize: "",
      imgList: [],
      imageUrl: "",
      qrcode: "",
      videoFile: "", //视频
      uploader: "",
      videoId: "",
      fileList: [],
      video: "",
      videoFlag: false,
      percentageImg: 0,
      percentageVideo: 0,
      videoUrl: "",
      timeout: null,
      imgHistory: [],
      videoHistory: [],
      fileListArr: [],
      fileListArrHistory: [],
      percentageFile: 0,
    };
  },
  methods: {
    toCode() {
      const {
        qrCodeInfo: { appid, path, width },
      } = this;
      if (appid) {
        let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
        axios
          .get(`https://xiao.gaodun.com/api/v1/token?appid=${appid}`)
          .then((res) => {
            const {
              data: {
                data: { access_token },
              },
            } = res;
            axios({
              url: "https://stark.pxo.cn/hiddenapi/User/getWxaQrCode",

              headers: {
                "Content-type": "application/x-www-form-urlencoded",
              },
              method: "POST",
              data: qs.stringify({
                access_token: access_token,
                path: path,
                width: width,
                work_number: UserInfo.userid,
                user_name: UserInfo.name,
              }),
            })
              .then((response) => {
                var qrcode = response;
                if (qrcode.data.status != 200) {
                  this.$message.error("生成失败,请重试");
                  return false;
                }
                this.qrCodeInfourl = qrcode.data.data;
              })
              .catch((ror) => {
                this.$message.error("生成失败,请重试");
                this.qrCodeInfourl = "";
              });
          })
          .catch((error) => {
            this.$message.error("获取access_token失败,请重试");
          });
      } else {
        this.$message.error("请填写appid");
      }
    },
    onCopy: function(e) {
      this.$message.success("复制成功");
    },
    onError: function(e) {
      this.$message.error("复制失败");
    },
    isWxBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      let isWx = ua.match(/wxwork/i);
      if (!isWx) {
        return false;
      } else {
        return true;
      }
    },
    // 生成二维码
    creatQrCode(img, index, item) {
      var self = this;
      this.$nextTick(() => {
        if (this.qrcode) {
          document.querySelector("#qrCodeUrl" + index).innerHTML = "";
        }
        this.qrcode = new QRCode("qrCodeUrl" + index, {
          text: img, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        var callback = function(records) {
          let canvas = document.querySelector("#qrCodeUrl" + index + " canvas");
          let src =
            document.querySelector("#qrCodeUrl" + index + " img").src ||
            canvas.toDataURL() ||
            "";
          let oldSrc = "";
          let nowSrc = "";
          nowSrc = src;
          if (oldSrc !== nowSrc) {
            self.$set(item, "erweImg", canvas.toDataURL());
          }
        };
        var mo = new MutationObserver(callback);
        var option = {
          childList: true,
          subtree: true,
          attributes: true,
        };
        mo.observe(document.querySelector(".home"), option);
        document.querySelector("#qrCodeUrl" + index + " img").style.width =
          "100%";
      });
    },

    changeQuality(item, index) {
      this.imgList.forEach((i, v) => {
        if (i.url == item.url) {
          let quaString = "";
          let sizeString = "";
          if (!i.chosedQuality) {
            quaString = "";
          } else {
            quaString = `quality,q_${i.chosedQuality}/`;
          }
          if (!i.chosedSize) {
            sizeString = "";
          } else {
            sizeString = `resize,m_lfit,w_${i.chosedSize}/`;
          }
          let url = `${i.url}?x-oss-process=image/auto-orient,1/${sizeString}${quaString}format,jpg`;
          this.$set(i, "erweima", url);
          this.$set(i, "imageUrl", url);
          this.creatQrCode(url, index, item);
        }
      });
    },
    changeSize(item, index) {
      this.imgList.forEach((i, v) => {
        if (i.url == item.url) {
          let quaString = "";
          let sizeString = "";
          if (!i.chosedQuality) {
            quaString = "";
          } else {
            quaString = `quality,q_${i.chosedQuality}/`;
          }
          if (!i.chosedSize) {
            sizeString = "";
          } else {
            sizeString = `resize,m_lfit,w_${i.chosedSize}/`;
          }
          let url = `${i.url}?x-oss-process=image/auto-orient,1/${sizeString}${quaString}format,jpg`;
          this.$set(i, "erweima", url);
          this.$set(i, "imageUrl", url);
          this.creatQrCode(url, index, item);
        }
      });
    },
    beforeUploadImg(file) {
      let that = this;
      let fileArr = file.raw;
      if (file.raw.type.indexOf("image") != -1) {
        var fd = new FormData();
        fd.append("file", fileArr);
        fd.append("gaodun_name", that.name);
        fd.append("gaodun_id", that.gaodun_id);
        fd.append("title", file.name);
        this.ajaxImg(fd, file, function(progressEvent) {
          let { loaded, total } = progressEvent;
          let percentageImg = Math.ceil((loaded / total) * 100);
          that.percentageImg = percentageImg;
        }).then((res) => {
          let item = {
            url: res,
            erweima: res,
            imageUrl: res, //input
            chosedSize: "", //选择的尺寸
            chosedQuality: "", //选择的质量
            erweImg: ".",
          };
          this.imgList = [item, ...this.imgList];
          this.imgList = JSON.parse(JSON.stringify(this.imgList));
          this.imgList.forEach((item, index) => {
            if (item.erweImg == ".") {
              this.creatQrCode(item.imageUrl, index, item);
            } else {
              item.erweImg = item.erweImg;
            }
          });
        });
      } else {
        this.$message.error("请选择图片");
      }
    },

    ajaxImg(fd, file, imgProgress) {
      return new Promise((resolve, reject) => {
        this.$axios
          .request({
            url: "/huizhanapi/Base/upload",
            method: "POST",
            data: fd,
            progress: imgProgress,
          })
          .then((res) => {
            if (res.status == 200) {
              resolve(res.data);
            }
          });
      });
    },
    initUploadHistory() {
      let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios
        .request({
          url: "/aliyunfileapi/AliyunFile/index",
          method: "get",
          data: {
            page: 1,
            create_name: UserInfo.name,
            gaodun_id: UserInfo.userid,
          },
        })
        .then((res) => {
          const {
            data: { list },
          } = res;
          this.fileListArrHistory = list;
        });
    },
    async handleHistory(utl) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      try {
        let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
        let res = await this.$axios.request({
          url: "/aliyunfileapi/AliyunFile/add ",
          method: "POST",
          data: {
            pic_path: utl,
            create_name: UserInfo.name,
            gaodun_id: UserInfo.userid,
            note: this.names.inputFileOriginName,
            file_name: this.names.originFileName,
          },
        });
        this.names.inputFileOriginName = "";
        this.precentage = 0;
        this.initUploadHistory();
      } catch (error) {}
    },

    async multipartUpload(name, file) {
      var _this = this;
      try {
        let client = new OSSFile(this.ossConfig);
        let tempCheckpoint;
        let result = await client.multipartUpload('file/'+name, file, {
          progress: function(p, checkpoint) {
            _this.precentage = +(p * 100).toFixed(2);
            tempCheckpoint = checkpoint;
          },
          meta: { year: 2020, people: "test" }
        });
        if (result) {
          const {
            res: { requestUrls },
          } = result;
          // debugger
          let utl = requestUrls[0];
          let isfindeIndex = utl.indexOf("?");
          let urls = "";
          if (isfindeIndex != -1) {
            urls = utl.substring(0, isfindeIndex);
          } else {
            urls = requestUrls[0];
          }
          _this.handleHistory(urls);
        }
      } catch (error) {}
    },
    ossFun(file) {
      this.names.originFileName = file.name;
      let lastStr = file.name.substring(file.name.indexOf("."));
      let name = new Date().getTime() + "" + lastStr;
      let tempCheckpoint;
      let that = this;
      this.multipartUpload(name, file);
    },
    // 文件
    beforeUploadFile(file) {
      let that = this;
      let permisiomType = [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "pdf",
        ".pdf",
        ".rar",
        ".zip",
        ".csv",
        ".txt",
        ".ppt",
        ".apk",
        ".pptx",
      ];
      let fileArr = file.raw;
      let lengthArr = file.raw.name.split(".");
      let fileType = lengthArr[lengthArr.length - 1] || "";
      let result = permisiomType.find((item, index) => {
        return "." + fileType.indexOf(item) != -1;
      });
      if (result) {
        that.ossFun(fileArr);
      } else {
        this.$message.error("请选择文件类型");
      }
    },
    //视频
    createUploader(params) {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: videoUploadConfig.timeout || 60000,
        partSize: videoUploadConfig.partSize || 1048576,
        parallel: videoUploadConfig.parallel || 5,
        retryCount: videoUploadConfig.retryCount || 3,
        retryDuration: videoUploadConfig.retryDuration || 2,
        region: videoUploadConfig.region,
        userId: videoUploadConfig.userId,
        // 添加文件成功
        addFileSuccess(uploadInfo) {
          self.$nextTick(() => {
            this.videoUrl = uploadInfo.file.path;
          });
        },
        // 开始上传
        onUploadstarted(uploadInfo) {
          // if (uploadInfo.videoId) {
          //   //刷新
          // }else{
          let createUrl = "/videoconfigapi/Videoconfig/add";

          self.$axios
            .request({
              url: createUrl,
              method: "post",
              progress: function(progressEvent) {},
              data: {
                filepath: uploadInfo.file.name,
                title: uploadInfo.file.name,
                gaodun_name: self.name,
                is_send_msg: 1,
                gaodun_id: self.gaodun_id,
                title: uploadInfo.file.name,
              },
            })
            .then(({ data }) => {
              let uploadAuth = data.OriUploadAuth;
              let uploadAddress = data.OriUploadAddress;
              let videoId = data.VideoId;
              self.videoId = videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
          //}
        },
        // 文件上传成功
        onUploadSucceed(uploadInfo) {
          self.$message({
            message:
              "视频已经上传成功,视频播放地址随后将通过企业微信消息推送给你,现在关闭当前窗口,不影响视频上传.",
            type: "success",
            duration: 50000,
          });
        },
        // 文件上传失败
        onUploadFailed(uploadInfo, code, message) {
          self.$message.error("文件上传失败!");
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress(uploadInfo, totalSize, progress) {
          videoUploadConfig.authProgress = Math.ceil(progress * 100);
          self.percentageVideo = parseInt(Math.ceil(progress * 100));

          if (progress === 1) {
            params.status = "done";
            params.message = "上传完成";
            self.getHistoryVideo();
          }
        },
        // 上传凭证超时
        onUploadTokenExpired(uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
        },
        // 全部文件上传结束
        onUploadEnd() {},
      });
      return uploader;
    },
    beforeUploadVideo(file, fileList) {
      if (file.raw.type.indexOf("video") !== -1) {
        this.videoFile = file.raw;
        if (!this.videoFile) {
          this.$message.error("请先选择需要上传的文件!");
          return;
        }
        let userData = '{"Vod":{}}';
        if (this.uploader) {
          this.uploader.stopUpload();
          videoUploadConfig.authProgress = 0;
        }
        this.uploader = this.createUploader(file);
        this.uploader.addFile(this.videoFile, null, null, null, userData);
        if (this.uploader !== null) {
          this.uploader.startUpload();
        }
      } else {
        Message.error("请选择视频");
      }
    },
    // 获取工号  登录
    async getUserId() {
      return new Promise((resolve, reject) => {
        this.$axios
          .request({
            url: "/hiddenapi/user/index?token=" + this.wxtoken,
          })
          .then((res) => {
            if (res.status == 200) {
              let { userid, name } = res.data;
              localStorage.setItem("userId", 123456789);
              localStorage.userInfo = JSON.stringify(res.data);
              this.userId = "123456789";
              this.gaodun_id = userid;
              this.name = name;
              this.getHistory();
              this.getHistoryVideo();
              resolve(res);
            }
          });
      });
    },
    // 获取上传token
    async getToken() {
      return new Promise((resolve, reject) => {
        this.$axios
          .request({
            // url: "/huizhanapi/Zhandui.Member/getToken",
            url: this.uploadUrl,
            method: "POST",
            data: {
              mobile:
                process.env.NODE_ENV === "development"
                  ? 123456789
                  : this.userId,
              getOssRam: 1,
            },
          })
          .then((res) => {
            if (res.status == 200) {
              this.token = res.token;
              this.tid = res.data.tid;
              let { accessKeyId, accessKeySecret, securityToken } = res.data;
              this.ossConfig = {
                ...this.ossConfig,
                accessKeyId: accessKeyId,
                accessKeySecret: accessKeySecret,
                stsToken: securityToken,
                refreshSTSToken: securityToken,
              };
              localStorage.setItem("token", this.token);
              resolve(res);
            }
          });
      });
    },
    // 授权
    async accredit() {
      let wxString = location.href.split("?")[1];
      let wxtoken = "";
      if (wxString) {
        wxtoken = wxString.split("#")[0];
        wxtoken = wxtoken.split("=")[1];
        localStorage.setItem("wxtoken", wxtoken);
        this.wxtoken = wxtoken;
      }
      if (!this.wxtoken || this.wxtoken == "undefinded") {
        location.href =
          API_LOGIN +
          "/index/v1/authorizelogin?url=" +
          encodeURIComponent(location.href);
      } else {
        let getUserIdResult = await this.getUserId();
        if (getUserIdResult.status == 200) {
          let getTokenResult = await this.getToken();
        }
      }
    },
    // 历史记录文件图片
    getHistory() {
      //图片 文件
      this.$axios
        .request({
          url: "/huizhanapi/Base/user_history",
          data: {
            page: 1,
            pageSize: 500,
            gaodun_id: this.gaodun_id,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            let permisiomType = [
              "doc",
              "docx",
              "xls",
              "xlsx",
              "pdf",
              ".pdf",
              ".rar",
              ".zip",
              ".csv",
              ".txt",
              ".ppt",
              ".apk",
              ".pptx",
            ];
            let { data } = res;
            data.forEach((item, index) => {
              let arr = item.pic_path.split(".");
              let postfix = arr[arr.length - 1];
              let result = permisiomType.find((pitem) => {
                return postfix.indexOf(pitem) != -1;
              });
              if (result) {
                this.fileListArrHistory = [...this.fileListArrHistory, item];
              } else {
                this.imgHistory = [...this.imgHistory, item];
              }
            });
          }
        });
    },
    // 上传历史视频
    getHistoryVideo() {
      //视频
      this.$axios
        .request({
          url: "/videoconfigapi/Videoconfig/user_history",
          data: {
            page: 1,
            pageSize: 50,
            gaodun_id: this.gaodun_id,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.videoHistory = res.data;
          }
        });
    },
  },
  async mounted() {
    let domain=document.domain;

    if(domain=='www.gwy.com'){
      this.ossConfig.bucket='attachment-gwy-com'
      this.uploadUrl='/huizhanapi/Zhandui.Member/getToken?domain=gwy'
    }

    let result = this.isWxBrowser();
    if (result) {
      this.accredit();
    } else {
      if (localStorage.getItem("wxtoken")) {
        this.wxtoken = localStorage.getItem("wxtoken");
        let getUserIdResult = await this.getUserId();
        if (getUserIdResult.status == 200) {
          let getTokenResult = await this.getToken();
        }
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    }
    this.initUploadHistory();
  },
};
</script>
<style lang="less" scoped>
.errorMessage {
  text-align: center;
  color: red;
  font-size: 16px;
  // margin-bottom: 20px;
}
.home {
  .inputWrapper {
    margin-top: 30px;
    .imgContent {
      width: 100%;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      div {
        width: 45%;
      }
      img {
        width: 100%;
      }
      .qrcode {
        width: 100%;
        img {
          width: 100%;
        }
      }
      // .erweima {
      //   width: 30%;
      //   height: 30%;
      //   margin-left: 10%;
      // }
    }

    .el-input,
    .el-select {
      margin-top: 10px;
      width: 100%;
    }
  }
  .alert {
    margin: 10px 0;
  }
}
.qrcode {
  display: inline-block;
  img {
    width: 132px;
    height: 132px;
    background-color: #fff; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
    box-sizing: border-box;
  }
}
.copyBtn {
  float: right;
}
.historyItem {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 0;
  img {
    width: 30%;
  }
  span,
  b {
    font-size: 20px;
  }
  video {
    width: 300px;
  }
}
.uploadVideoContainer {
  // width: 180px;
  // height: 180px;
  // position: relative;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.el-progress {
}
</style>
